export default __webpack_public_path__ + "static/media/me.9724e1c1.png";